import { invertObj } from 'ramda';

export const parse = ({ value, displayValuesMap, maxValue }: {
    value: string;
    displayValuesMap: Record<string, string>;
    maxValue: string;
}) => {
    const displayValue = value.trim();

    const displayValuesMapInverted = invertObj(displayValuesMap);

    if (Number(displayValue) > Number(maxValue)) {
        return maxValue;
    }

    if (displayValue in displayValuesMapInverted) {
        return displayValuesMapInverted[displayValue];
    }

    return displayValue;
};

export const format = ({ value, displayValuesMap }:{
    value: string;
    displayValuesMap: Record<string, string>;
}) => {
    const input = value in displayValuesMap ? displayValuesMap[value] : value;

    return { input, select: value };
};
